import "./column-components.b616e6f0.js";
import {hyperStyled as $3wcZx$hyperStyled} from "@macrostrat/hyper";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea149"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea149"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;


var $8c0gQ = parcelRequire("8c0gQ");
const $08d03f79761cfb1b$var$h = (0, $3wcZx$hyperStyled)((0, (/*@__PURE__*/$parcel$interopDefault($8c0gQ))));
var $08d03f79761cfb1b$export$2e2bcd8739ae039 = $08d03f79761cfb1b$var$h;


export {$08d03f79761cfb1b$export$2e2bcd8739ae039 as default};
//# sourceMappingURL=column-components.746beab7.js.map
